import React, { useEffect, useState } from "react";

import { Input, Label, UncontrolledTooltip } from "reactstrap";

import { inputMask } from "../../../../utils/helpers/masks/masks";
import { validation } from "../../../../utils/helpers/masks/validations";

export default function CPFDisplay({
  attributes,
  rowId,
  colId,
  setValue,
  submitted,
}) {
  // Mask — inicializa com attributes.value para suportar pré-preenchimento de respostas salvas
  const [maskedValue, setMaskedValue] = useState(attributes.value || "");

  // Validação
  const [cpfError, setCpfError] = useState("");
  // Marca que o usuário já saiu do campo (blur) — dispara feedback de erro
  // sem esperar o submit. Combinado com `submitted` também funciona no click.
  const [touched, setTouched] = useState(false);

  const handleChange = (value) => {
    inputMask({ mask: "cpf", value, setMaskedValue });
  };

  useEffect(() => {
    const html = attributes.label;
    const div = document.getElementsByClassName(`cpf-label-${rowId}-${colId}`);

    for (const element of div) {
      element.innerHTML = html + (attributes.required ? "*" : "");
    }
  }, [attributes, rowId, colId]);

  useEffect(() => {
    const { isValid, message } = validation(maskedValue, "cpf");
    const digits = maskedValue.replace(/\D/g, "");
    const isComplete = digits.length === 11;

    let inlineMsg = "";
    if (maskedValue && !isComplete) {
      inlineMsg = "CPF incompleto";
    } else if (isComplete && !isValid) {
      inlineMsg = message;
    }

    // Mostra o erro se o usuário já saiu do campo (touched) OU já tentou
    // submeter (submitted). Combina as duas fontes de "hora de mostrar erro".
    setCpfError(touched || submitted ? inlineMsg : "");

    setValue((oldValue) => {
      const newValue = [...oldValue];
      newValue[rowId].cols[colId].attributes.value = maskedValue;
      // errorMessage: apenas para campo vazio (FormMounted exibe "obrigatório" no submit)
      newValue[rowId].cols[colId].attributes.errorMessage =
        maskedValue === "" && !isValid ? message : "";
      // inlineError: bloqueia submit para qualquer CPF não vazio e inválido (incompleto ou com dígitos errados)
      newValue[rowId].cols[colId].attributes.inlineError = inlineMsg;
      return newValue;
    });
  }, [maskedValue, setValue, rowId, colId, submitted, touched]);

  return (
    <div>
      <div className="custom-input-container">
        <div>
          <div className="displayed-config-container">
            <div className="displayed-label">
              {/* FIX_SSR_LABEL */}
              <Label
                htmlFor="formText"
                className={`form-label cpf-label-${rowId}-${colId}`}
                style={{ display: "inline", marginRight: 2 }}
              >
                {attributes.label}
              </Label>
              {attributes.hasTip && (
                <div>
                  <div className="show-tips" id={`cpf-tip-${rowId}-${colId}`}>
                    <span>?</span>
                  </div>
                  <UncontrolledTooltip
                    style={{ backgroundColor: "#6f42c1" }}
                    placement="right"
                    target={`cpf-tip-${rowId}-${colId}`}
                  >
                    {attributes.tipText}
                  </UncontrolledTooltip>
                </div>
              )}
            </div>
          </div>
          <Input
            className="form-control"
            type="text"
            id="formText"
            placeholder={attributes.placeholder}
            value={maskedValue}
            onChange={({ target }) => handleChange(target.value)}
            onBlur={() => setTouched(true)}
          />
          {cpfError && (
            <span style={{ color: "red", marginTop: 15, marginBottom: "-15px", display: "flex" }}>
              {cpfError}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
